function computeStatus(status) {
  switch (status) {
    case 1:
      return "Hiring";
    case 2:
      return "Hiring";
    case 3:
      return "Closed";
    case 4:
      return "Ongoing";
    case 5:
      return "Archived";
    case 6:
      return "Completed";
    default:
      return "";
  }
}

function computeDuration(duration) {
  switch (duration) {
    case 1:
      return "3 months";
    case 2:
      return "6 months";
    case 3:
      return "1 year or more";
    default:
      return "not specified";
  }
}

function computeComplexity(complexity) {
  switch (complexity) {
    case 1:
      return "easy";
    case 2:
      return "medium";
    case 3:
      return "hard";
    default:
      return "not specified";
  }
}

function computeExperienceLevel(complexity) {
  switch (complexity) {
    case 0:
      return "not specified";
    case 1:
      return "junior";
    case 2:
      return "intemediate";
    case 3:
      return "senior";
    default:
      return "not specified";
  }
}

function computeCommitment(commitment) {
  switch (commitment) {
    case 1:
      return "40 or more hrs/week (Full time)";
    case 2:
      return "Less than 40 hrs/week (Part time)";
    case 3:
      return "Hourly";
    case 4:
      return "Don't know yet";
    default:
      return "not specified";
  }
}

function computeLocation(location) {
  if (location) {
    return location;
  }
  return "not specified";
}

export {
  computeStatus,
  computeDuration,
  computeComplexity,
  computeCommitment,
  computeLocation,
  computeExperienceLevel
};
